// @flow
import React from "react";
import { Route, Link } from "react-router-dom";
import cx from "classnames";
import glamorous from "glamorous";

type TabProps = {
    path: string,
    title: string,
};

type TabsProps = {
    items: any[],
    className?: string
};

const TabDiv = glamorous.div(({ match }) => cx("tc flex-grow", {
	"bc-link c-link": match,
	"bc-window bg-window-c": !match,
}), {
	minWidth: 100,
	padding: "14px 10px 7px 10px",
	borderBottomWidth: 2,
	borderBottomStyle: "solid",
	"& a": {
		display: "inline-block",
		width: "100%",
		height: "100%",
	},
});

const Tab = ({ title, path }: TabProps) => <Route path={path} exact>
	{({ match }) => <TabDiv match={match}>
		<Link to={path}>{title}</Link>  {/* eslint-disable-line jsx-a11y/anchor-is-valid */}
	</TabDiv>}
</Route>;

export const Tabs = ({ items, className = "" } : TabsProps) => {
	const cls = cx("inline-flex flex-grow items-center justify-stretch", "window-bg bg-window-c", className);

	return <div className={cls}>
		{items.map((item) => <Tab path={item.path} title={item.title} key={item.path}/>)}
	</div>;
};

export default Tabs;
